<app-system-message></app-system-message>
<!-- Load icon -->
@if (isLoading) {
<div class="container-fluid">
  <nav [ngClass]="theme.getThemeClass()" class="loading-gif">
    <div class="box fade-in-out">
      <div class="fa-3x mb-2">
        <i class="fa-solid fa-spinner fa-spin-pulse fa-2xl color"></i>
      </div>
      <div>
        <a
          [ngClass]="theme.getThemeClass()"
          class=" hide-too-small-screen navbar-brand px-1"
          href="javascript:void(0);"
          data-bs-toggle="dropdown"
        >
          <img class="logo" src="../assets/muirwood-studio.png" />
        </a>
      </div>
    </div>
  </nav>
</div>
}

<!-- Main Content -->
@if (!isLoading) {
<div [ngClass]="[theme.getThemeClass(), workOrderModalService.showModal ? 'grayed-out' : '']">
  <header class="page-header">
    <h2>{{ "workOrderList" | translate }}</h2>
  </header>
  <nav id="search-component" class="nav-sort-filter">
    <select
      class="form-control"
      [(ngModel)]="workOrderService.workOrderData.work_order_status"
      (change)="onFilterByStatusChange()"
      [ngClass]="{ hasValue: workOrderService.workOrderData.work_order_status }"
      aria-label="Work Order Status"
      aria-describedby="basic-addon1"
      name="work_order_status"
    >
      <option value="">{{ 'workOrderStatus' | translate }}</option>
      @for (option of workOrderStatusOptions(); track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
    &nbsp;
    <select
      class="form-control"
      [(ngModel)]="workOrderService.workOrderData.work_order_type"
      (change)="onFilterByTypeChange()"
      [ngClass]="{ hasValue: workOrderService.workOrderData.work_order_type }"
      aria-label="Work Order Type"
      aria-describedby="basic-addon1"
      name="work_order_type"
    >
      <option value="">{{ 'workOrderType' | translate }}</option>
      @for (option of workOrderTypeOptions(); track option.value) {
        <option [value]="option.value">{{ option.label | translate }}</option>
      }
    </select>
  </nav>
  <section class="createBtns d-flex justify-content-center mb-2">
    <button [ngClass]="theme.getThemeClass()" class="btn btn-dropdown" routerLink="/work-order-create">
      {{ "createWorkOrder" | translate }}
    </button>
  </section>
  <div class="grid-container">
    <section [ngClass]="theme.getThemeClass()" class="gridster" [ngStyle]="getColumnStyle()" style="height: 100vh!important;">
      @for (item of workOrderArray; track item.work_order_id) {
      <article class="gridster-item">
        <nav [ngClass]="theme.getThemeClass()" class="dashboard-tile">
          <header class="dashboard-tile-header">
            <h6 class="dashboard-tile-title">{{ item.work_order_id }}</h6>
          </header>
          <div class="tiles-container">
            <div class="work-order-owner-infos">
              <div>
                <i class="fa-solid fa-circle-question"></i><label class="item-label">{{ item.work_order_type | translate }}</label>
              </div>
              <div>
                <i class="fa-solid fa-user"></i><label class="item-label">{{ item.legal_name }}</label>
              </div>
              <div>
                <i class="fa fa-trash"></i><label class="item-label">{{ item.bin_id }}</label>
              </div>
              @if (item.thing_name) {
              <div>
                <i class="fa-solid fa-microchip device-icon"></i><label class="item-label">{{ item.thing_name }}</label>
              </div>
              }
            </div>
            <hr />
            <div class="work-order-infos">
              <div>
                <a [ngClass]="theme.getThemeClass()" (click)="changeWorkOrderStatus(item)">
                  <i class="fa-solid fa-hourglass-start"></i>
                  <label class="item-label label-clickable">{{ item.status | translate }}</label></a
                >
              </div>
              <div>
                <a [ngClass]="theme.getThemeClass()" (click)="changeWorkOrderDeadlineDate(item)">
                  <i class="fa-regular fa-calendar"></i>
                  <label class="item-label label-clickable">{{ item.work_order_deadline | formatDate }}</label></a
                >
              </div>
              <div class="work-order-description">
                <a [ngClass]="theme.getThemeClass()" (click)="changeWorkOrderDescription(item)" class="comments-div">
                  <i class="fa-solid fa-circle-question"></i>
                  <label class="item-label label-clickable">{{ item.description | translate }}</label></a>
              </div>
              <hr />
              <label>{{ "comments" | translate }}</label>
              <div class="work-order-comments">
                <a [ngClass]="theme.getThemeClass()" (click)="changeWorkOrderComments(item)">
                  <i class="fa-solid fa-comment"></i>
                  <label class="item-label label-clickable">{{ item.comment | translate }}</label></a
                >
              </div>
            </div>
          </div>
        </nav>
      </article>
      }
      <div style="height: 500px !important; width: 10px !important;"></div>
    </section>
  </div>
</div>
}
@if (workOrderModalService.showModal) {
<app-work-order-dashboard-modal></app-work-order-dashboard-modal>
}
